import InputError from '@/components/inputs/base/InputError.vue'
import { SearchCircleIcon, SearchIcon } from '@heroicons/vue/outline'
import { getCurrentInstance, PropType } from 'vue'
import { SelectOption, PartialField } from '@/types/general/FieldType'
import { NestedObject } from '@/types/general/utilTypes'
import { escape } from 'lodash-es'

export const InputFieldProps = {
    modelValue: {
        type: [String, Array as PropType<SelectOption[]>, Object as PropType<NestedObject>, Number, Boolean],
        default: null,
    },
    name: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    ariaDescribedBy: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Object as PropType<NestedObject | string | null>,
        default: null,
    },
    editMode: {
        type: Boolean,
        default: false,
    },
    inputClasses: {
        type: String,
        default: '',
    },
    previewClasses: {
        type: String,
        default: '',
    },
    field: {
        type: Object as PropType<PartialField>,
        required: true,
        default: {

        },
    },
    isFilterField: {
        type: Boolean,
        default: false,
    },
    record: {
        type: Object,
        default: {

        },
    },
    indexLabel: {
        type: [Object, Number, String, Boolean],
        default: null,
    },
    values: {
        type: Array as PropType<SelectOption[]>,
        default: [],
    },
    recordId: {
        type: Number,
        required: false,
    },
    view: {
        type: String,
        default: 'detail',
    },
}

export const SelectFieldProps = {
    selectedOptions: {
        type: Array as PropType<SelectOption[]>,
        default: [],
    },
    isLoadingOptions: {
        type: Boolean,
        default: false,
    },
    comboboxOptionsWidth: {
        type: String,
        default: 'w-full',
    },
}

export const InputFieldComponents = {
    SearchCircleIcon,
    SearchIcon,
    InputError,
}

export const InputFieldEmits = [
    'update:modelValue',
]

export default function() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { emit, props } = getCurrentInstance() as any

    function updateValue(value: null|string|NestedObject|number|boolean|Array<string|number>) {
        emit('update:modelValue', value)
    }

    function trimValue(field:NestedObject, value: null|string|NestedObject|number|boolean|Array<string|number>) {
        if (field.type === 'money' || field.type === 'quantity' && !props.isFilterField) {
            emit('update:modelValue', value?.toString().replace(/\s+/g, ''))
        }
    }

    const getLabel = () => {
        let label = escape(props.label ? props.label + ':' : '')

        if (props.field.mandatory) {
            label = '<span class="text-red-600" data-cy="mandatory-field">*&nbsp;</span>' + label
        }

        return label
    }

    const clearValue = () => {
        emit('update:modelValue', '')
    }

    return {
        updateValue,
        trimValue,
        clearValue,
        getLabel,
    }
}
